import {
  userSlice,
  amlHistorySlice,
  twoFASlice,
  profileSlice,
  promoHistorySlice,
  amlCheckSlice,
  investigationHistorySlice,
  serviceOptionsSlice,
  paymentSlice,
  blockSlice,
  personalInfoModalSlice,
  twoFAActivateModalSlice,
  twoFADeActivateModalSlice,
  criticalBalanceAlertModalSlice,
  shareBalanceModalSlice,
  checkMethodModalSlice,
  checkBatchSlice,
  addressMonitoringSlice,
  receiveRemindersModalSlice,
  webSocketSlice,
  complianceAuthTokenSlice,
  complianceStatsSlice,
  complianceCategoryStatsSlice,
  complianceTransferSlice,
  complianceAlertStatsSlice,
  complianceAlertsSlice,
  complianceCustomersSlice,
  complianceAlertLevelsSlice,
  complianceListsSlice,
  externalServiceSlice,
  riskscoreProfilesSlice,
  alertRulesSlice,
  amlTraceSlice,
  amlTraceHistorySlice,
} from '../slices';

const rootReducer = {
  [userSlice.name]: userSlice.reducer,
  [amlHistorySlice.name]: amlHistorySlice.reducer,
  [twoFASlice.name]: twoFASlice.reducer,
  [profileSlice.name]: profileSlice.reducer,
  [promoHistorySlice.name]: promoHistorySlice.reducer,
  [amlCheckSlice.name]: amlCheckSlice.reducer,
  [investigationHistorySlice.name]: investigationHistorySlice.reducer,
  [serviceOptionsSlice.name]: serviceOptionsSlice.reducer,
  [paymentSlice.name]: paymentSlice.reducer,
  [blockSlice.name]: blockSlice.reducer,
  [personalInfoModalSlice.name]: personalInfoModalSlice.reducer,
  [twoFAActivateModalSlice.name]: twoFAActivateModalSlice.reducer,
  [twoFADeActivateModalSlice.name]: twoFADeActivateModalSlice.reducer,
  [criticalBalanceAlertModalSlice.name]: criticalBalanceAlertModalSlice.reducer,
  [shareBalanceModalSlice.name]: shareBalanceModalSlice.reducer,
  [checkMethodModalSlice.name]: checkMethodModalSlice.reducer,
  [checkBatchSlice.name]: checkBatchSlice.reducer,
  [addressMonitoringSlice.name]: addressMonitoringSlice.reducer,
  [receiveRemindersModalSlice.name]: receiveRemindersModalSlice.reducer,
  [webSocketSlice.name]: webSocketSlice.reducer,
  [complianceAuthTokenSlice.name]: complianceAuthTokenSlice.reducer,
  [complianceStatsSlice.name]: complianceStatsSlice.reducer,
  [complianceCategoryStatsSlice.name]: complianceCategoryStatsSlice.reducer,
  [complianceTransferSlice.name]: complianceTransferSlice.reducer,
  [complianceAlertStatsSlice.name]: complianceAlertStatsSlice.reducer,
  [complianceAlertsSlice.name]: complianceAlertsSlice.reducer,
  [complianceCustomersSlice.name]: complianceCustomersSlice.reducer,
  [complianceAlertLevelsSlice.name]: complianceAlertLevelsSlice.reducer,
  [complianceListsSlice.name]: complianceListsSlice.reducer,
  [externalServiceSlice.name]: externalServiceSlice.reducer,
  [riskscoreProfilesSlice.name]: riskscoreProfilesSlice.reducer,
  [alertRulesSlice.name]: alertRulesSlice.reducer,
  [amlTraceSlice.name]: amlTraceSlice.reducer,
  [amlTraceHistorySlice.name]: amlTraceHistorySlice.reducer,
};

export default rootReducer;
